import {
  EventAction,
  EventLabel,
  InteractionEvent,
  type TrackingData,
} from '@/helpers/GTM/GTMHelper';

import type { MenuItem } from '@smg-real-estate/domus';

export function handleTrackHeaderClick(data: TrackingData): void {
  const dataObj: any = {
    event: InteractionEvent.HEADER_CLICK,
    h_event_category_006: InteractionEvent.HEADER_CLICK,
    h_event_action_007: data.eventAction,
    h_event_label_008: data.eventLabel,
    ...(data.contentLanguage && { h_content_language_116: data.contentLanguage }),
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(dataObj);
}

const hasTrackingLabel = (menuItem: MenuItem): menuItem is MenuItem & { trackingLabel: string } => {
  return 'trackingLabel' in menuItem && typeof menuItem.trackingLabel === 'string';
};

const getTrackingLabel = (menuItem: MenuItem): string => {
  if (hasTrackingLabel(menuItem)) {
    return menuItem.trackingLabel;
  }
  return EventAction.OPEN_MY_ACCOUNT;
};

export function handleNavTracking(
  menuItem: MenuItem,
  _event: Event,
  isMobile = false,
  locale?: string,
) {
  const eventLabel: string = isMobile ? EventLabel.SIDEBAR : EventLabel.TAB_NAVIGATION;
  handleTrackHeaderClick({
    eventAction: getTrackingLabel(menuItem),
    eventLabel,
    contentLanguage: locale,
  });
}
